import React from 'react';
import PropTypes from 'prop-types';

import { titleStyle, collaborationsStyle, bodyStyle, wrapperStyle } from './styles';

class ResearchStaticCardComponent extends React.PureComponent {
	render() {
		const { title, collaborations, body } = this.props;

		return (
			<article className={wrapperStyle} data-component="Card">
				<h1 className={titleStyle}>{title}</h1>
				{ collaborations && (
					<h2 className={collaborationsStyle}>{collaborations}</h2>
				) }
				<div className={bodyStyle} dangerouslySetInnerHTML={{ __html: body }} />
			</article>
		);
	}
}

ResearchStaticCardComponent.propTypes = {
	title: PropTypes.string,
	collaborations: PropTypes.string,
	body: PropTypes.string,
};

export const ResearchStaticCard = ResearchStaticCardComponent;



// WEBPACK FOOTER //
// ./src/components/shared/cards/researchStaticCard/component.js